"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrNewsletterFormUnsubscribe = void 0;
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const Yup = __importStar(require("yup"));
const components_common_checkbox_1 = require("@hotelplan/components.common.checkbox");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
const fdr_newsletter_form_unsubscribe_styles_1 = require("./fdr-newsletter-form-unsubscribe.styles");
const FdrNewsletterFormUnsubscribeValidationSchema = Yup.object({
    email: Yup.string()
        .email('forms:errors.email.invalid')
        .matches(/\.[a-z]{2,}$/i, 'forms:errors.email.invalid')
        .required('forms:errors.required'),
});
const FdrNewsletterFormUnsubscribe = ({ email, onSubmit, loading, availableTypes, submitButtonIcon, }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'newsletter']);
    return (react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: { email }, validationSchema: FdrNewsletterFormUnsubscribeValidationSchema }, formik => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(fdr_newsletter_form_unsubscribe_styles_1.FdrUnsubscribeForm, { noValidate: true, onSubmit: (e) => {
                    formik.handleSubmit(e);
                } },
                (availableTypes === null || availableTypes === void 0 ? void 0 : availableTypes.length) ? (react_1.default.createElement(fdr_newsletter_form_unsubscribe_styles_1.FdrCheckboxesWrapper, null, availableTypes.map(type => {
                    const { label, value, className } = type;
                    return (react_1.default.createElement(components_common_checkbox_1.Checkbox, { key: value, name: value, className: className || '', value: formik.values[value] ? value : undefined, checked: formik.values[value], content: label, onChange: (_, e) => formik.handleChange(e) }));
                }))) : null,
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { name: "email", type: "email", className: "unsubscribe-text-input", label: t('forms:email.label'), readOnly: true, required: true }),
                react_1.default.createElement(fdr_newsletter_form_unsubscribe_styles_1.FdrSubmitButtonWrapper, null,
                    react_1.default.createElement(core_fusion_bs_button_with_icon_1.BsButtonWithIcon, { type: "submit", className: "form-submit-button", disabled: formik.isSubmitting || loading, icon: submitButtonIcon },
                        react_1.default.createElement("span", { className: "button-text" }, t('forms:confirm.unsubscribe')))))));
    }));
};
exports.FdrNewsletterFormUnsubscribe = FdrNewsletterFormUnsubscribe;
//# sourceMappingURL=fdr-newsletter-form-unsubscribe.js.map